import { Paths } from "../constants/UrlConstants";
import { ButtonConfig, InboxPages } from "../constants/Constants";

const MakeAComplaintSmartLink = {
  linkText: "I'm dissatisfied",
  pathTo: `${Paths.MessageCentre}?page=${InboxPages.Complaints}`,
  iconName: "icon-functional-help",
  id:ButtonConfig.Iamdissatisfied
};

export default MakeAComplaintSmartLink;
